import React from 'react';
import IllustrationsGrid from '../common_components/IllustrationsGrid';
import CmykSmall from '../common_components/design_components/CmykSmall';
import Mark from '../common_components/design_components/Mark';
import '../styles/Illustrations.scss';

const IllustrationsPage = () => {
  return (
    <div>
      {/* Title Section */}
      <div className="illustrations-header">
        <div className="illustrations-title">
          <div className="illustration-mark-container">
            <Mark />
          </div>
          <h1>ILLUSTRATIONS</h1>
          <div className="small-cmyk-container-illustration">
            <CmykSmall />
          </div>
          <div className="illustration-mark-container">
            <Mark />
          </div>
        </div>
        <p className="illustrations-description">
        A collection of digital illustrations designed as assets for marketing projects. These visuals are created to enhance campaigns with unique, engaging, and adaptable designs.
        </p>
      </div>

      {/* Grid Section */}
      <IllustrationsGrid />
    </div>
  );
};

export default IllustrationsPage;
